import { effect, inject } from '@angular/core';
import { signalStore, withHooks, withState } from '@ngrx/signals';
import { BaseState, withCrudOperations } from '../crud.state';
import { Image } from '../../models/image';
import { withImageSelectors } from './image.selectors';
import { ImageService } from '../../services/image/image.service';
import { ActiveUserStore } from '../user/active-user.state';
import { withLogging } from '../features/logger.feature';

export type ImageState = BaseState<Image>;

export const initialState: ImageState = {
  items: {},
  loading: false,
  selectedId: '',
  selection: [],
  initialized: false,
  itemsLoaded: false,
  version: 0,
  lastPersistedId: '',
  trigger: undefined,
  entityType: 'Image',
  entityLabel: 'Schlagwort',
  filter: {
    query: '',
    category: [],
    tags: undefined,
    products: undefined,
    published: null,
    locked: null,
    ids: undefined,
  },
};

export const ImageStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withCrudOperations<Image>(ImageService),
  withLogging(initialState.entityType),
  withImageSelectors(),
  withHooks({
    onInit(store, activeUserStore = inject(ActiveUserStore)) {
      // See category.state.ts for why this watches commune reactively
      // instead of firing once at construction time.
      effect(
        () => {
          if (activeUserStore.commune()) {
            store.loadAllItemsByPromise();
          }
        },
        { allowSignalWrites: true }
      );
    },
  })
);
